<template>
  <l-layout :layout="['xs12']" bottom-space>
    <v-card>
      <l-data-table
      :headers="header"
      :get-data-func="getRuleTemplateList"
      @click:row="getDetails($event.item)"
      clickable
      ref="ruleTemplateList"
      title-text="计费规则模板列表"
      search-text="请输入模板名称">
        <template slot="row-action" slot-scope="{item}">
          <td @click.stop class="px-0 mx-0 text-xs-center">
            <v-tooltip left>
              <v-btn @click="deleteRuleTemplateConfirm(item)" slot="activator" icon>
                <v-icon small>$vuetify.icons.delete</v-icon>
              </v-btn>
              <span>删除配置</span>
            </v-tooltip>
          </td>
        </template>
      </l-data-table>
      <l-fixed-btn
        @click="addTemplate"
        icon="$vuetify.icons.add"
      ></l-fixed-btn>
    </v-card>
  </l-layout>
</template>
<script>
import {time} from '../../../ladmin/utils/time'
export default{
  name: 'ruleTemplateList',
  data () {
    return {
      header: [
        {text: '模板名称', value: 'name', align: 'left', sortable: false},
        {text: '创建时间', value: 'creationTime', align: 'left', sortable: true, f: (v) => time.stringify(new Date(v))},
        {text: '创建人', value: 'creator', align: 'left', sortable: false},
        {text: '模板状态', value: 'status', align: 'left', sortable: false},
        {text: '', value: '', align: 'left', sortable: false},
      ]
    }
  },
  methods: {
    async getRuleTemplateList ({pagination, sortStack, filterItems, search}) {
      let {items, amount} = await this.$store.dispatch('charging/getRuleTemplateList', {pagination, sortStack, filter: filterItems, search: {key: 'name', value: search}})
      return {items, amount}
    },
    addTemplate () {
      this.$router.push({name: 'ruleTemplate', query: {status: 'new', id: ''}})
    },
    async deleteRuleTemplateConfirm (item) {
      let {res, close} = await this.$L.confirm({
        title: '确认删除该模板？',
        text: '模板名称:' + item.name
      })
      if (res) {
        try {
          await this.deleteRuleTemplate(item)
        }
        catch (e) {
          this.$L.alert('error', e.message)
        }
      }
      close()
    },
    async deleteRuleTemplate (item) {
      let res = await this.$store.dispatch('charging/deleteRuleTemplate', item.id)
      if (res.data.status + '' === '200') {
        this.$L.alert('success', {message: '删除成功'})
        this.$refs.ruleTemplateList.refresh()
      }
      else {
        this.$L.alert('error', {message: '删除失败，原因：' + res.data.msg})
      }
    },
    getDetails (item) {
      let selectionString = document.getSelection().toString()
      if (!selectionString) {
        this.$router.push({name: 'ruleTemplate', query: {id: item.id, status: 'readonly'}})
      }
    }
  },
  mounted () {
    this.$refs.ruleTemplateList.refresh()
  },
  activated () {
    this.$refs.ruleTemplateList.refresh()
  }
}
</script>
